import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  allVerticalsParam,
  clearLocalStorage,
  clickTracker,
  getSourceValue,
  getUserType,
  hasJdMartVertical,
  trackUserType,
} from '../../../lib/common';
import { useAppState } from '../../../contexts/appState';
import { useAuth } from '../../../contexts/auth';
import { useSelectedBusiness, useSessionStorage } from '../../../hooks';
import { handlAuthUserDetails } from '../../../reducersAndActions/actions/authAction';
import { getAddOnCampaigns, GetOptions, GetTickets, handleImpressionsTrack } from '../../../api';
import { onClickEvent } from '../../../lib/gaAnalytics';
import { handleSetOptionsData, handleSetTicketsData } from '../../../reducersAndActions/actions/appStateActions';
import { Business, Shimmer } from '../../common';
import MyTickets from '../MyTickets';
import DynamicSearchBar from '../../DynamicSearchBar';
import styles from '../../../styles/TicketsHome.module.scss';
import EcsInactiveModal from '../../Ecs/EcsInactiveModal/EcsInactiveModal';
import AddOnModal from '../../AddOnModal/AddOnModal';
import useAlert from '../../../hooks/useAlert';
import KycPendingModal from '../../common/KycPending/KycPendingModal';
import KycPendingFooter from '../../common/KycPendingFooter/KycPendingFooter';

const LoggedIn = (props) => {
  const {
    handleOptionClick,
    isBusinessChange,
    setOptionsTrackerData,
    handleOnLanding,
    kycStatus = '',
    kycRedirectUrl,
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const source = getSourceValue();
  const [appState, dispatch] = useAppState();
  const [authState] = useAuth();
  const [loader, setLoader] = useState(false);
  const [contractType, setContractType] = useSessionStorage('contractType', '');
  const { setSelectedBusinessState } = useSelectedBusiness();
  const [myTicketsLoading, setMyTicketsLoading] = useState(false);
  const [myTicketsData, setMyTicketsData] = useState([]);
  const [optionsData, setOptionsData] = useState([]);
  const { selectedBusiness, type, userDetails, sidResponse } = authState;
  const searchParams = new URLSearchParams(location.search);
  const [ecsInactivePopupData, setEcsInactivePopupData] = useState({});
  const [storedInactiveDataArr, setStoredInactiveDataArr] = useState({});
  const [addOnsData, setAddOnsData] = useState([]);
  const [setAlert] = useAlert();

  const addQueryParam = (key, value) => {
    searchParams.set(key, value);
    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    navigate(newUrl, { replace: true });
  };
  const resetCsportalUser = () => {
    clearLocalStorage();
    setSelectedBusinessState({});
    handlAuthUserDetails(dispatch, { csportalType: '' });
    window.location.reload();
  };

  const [showKycPopup, setShowKycPopup] = useState(sessionStorage.getItem('kycPopupDismissed') !== '1');
  const [showKycBanner, setShowKycBanner] = useState(sessionStorage.getItem('kycBannerDismissed') !== '1');

  const getOptions = async () => {
    try {
      // const type = isBusinessActive() ? 'business' : 'user';
      const docId = (selectedBusiness && selectedBusiness?.docid) || '';

      if (type === 'business' && (!selectedBusiness || !selectedBusiness.parentid || !selectedBusiness.data_city)) {
        return;
      }
      setLoader(true);
      const res = await GetOptions(
        type,
        docId,
        (selectedBusiness && selectedBusiness?.parentid) || '',
        (selectedBusiness && selectedBusiness?.data_city) || '',
        source,
        selectedBusiness?.shorturl || '',
      );

      if (getUserType?.[res?.contractType]) {
        onClickEvent(
          `CSMain-${getUserType?.[res?.contractType] || ''}`,
          getUserType?.[res?.contractType] || '',
          getUserType?.[res?.contractType] || '',
        );
      }

      if (!res || !res.options || !res.options.length) {
        throw new Error();
      }

      let ecsFlag = false;
      let jdrrBannerFlag = false;
      res.options.forEach((option) => {
        if (option?.key === 'ECS') ecsFlag = true;

        if (option?.type === 'others' && option?.length > 0) {
          option.forEach((ele) => {
            if (ele?.key === 'Banner-JDRR') jdrrBannerFlag = true;
          });
          ecsFlag = true;
        }
      });

      setEcsInactivePopupData(res?.ecsDetailsResp || {});
      const ecsInactiveData = JSON.parse(localStorage.getItem('ecsInactiveData')) || [];
      const storedInactiveData = ecsInactiveData?.find((each) => each?.docid === selectedBusiness?.docid);
      setStoredInactiveDataArr(storedInactiveData);

      if (res?.ecsDetailsResp?.ecsStatus) {
        const liVal = 'impression';
        const liTrd = 'ecsprompt';
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = 'ecsprompt';
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
      const jdCorporateVerticalValue = res?.jdCorporateVertical ? res?.jdCorporateVertical : '';
      sessionStorage.setItem('jdCorporateVertical', JSON.stringify(jdCorporateVerticalValue || ''));
      sessionStorage.setItem('isLawyerCategory', JSON.stringify(res?.isLawyerCategory || false));
      sessionStorage.setItem('ecsFlag', JSON.stringify(res?.ecsFlag || 0));

      setOptionsTrackerData(res);
      setOptionsData(res.options);
      handleSetOptionsData(dispatch, {
        optionsData: { options: res.options, contractType: res?.contractType, ecsFlag, jdrrBannerFlag },
      });
      setContractType(res?.contractType);
      addQueryParam('type', res?.contractType);

      setLoader(false);
    } catch (error) {
      resetCsportalUser();
      // console.log('error in loggedIn ');
    }
  };

  const getTicketsData = async (mobile = '') => {
    try {
      setMyTicketsLoading(true);
      if (type) {
        const docIdObj = {
          docId: selectedBusiness?.docid || '',
          src_typ: 'call,whatsapp,csportal',
        };
        const portalFlag = 1;
        const params = {
          category: 'CS',
          vertical: type === 'user' ? 'USER EXPERIENCE' : allVerticalsParam,
          allocEmpid: '',
          page: 1,
          limit: 5,
          search: docIdObj,
          sortBy: '',
          ticketCreator: '',
          download: 0,
          portalFlag,
          emails: undefined,
          _status: '',
          ticketId: '',
          genioMyTicketsFlag: '',
          grEligible: '',
          src_mob: type === 'user' ? mobile || userDetails?.mobile : '',
        };
        const res = await GetTickets(params);
        setMyTicketsData(res?.data || []);
        handleSetTicketsData(dispatch, {
          ticketsData: res?.data || [],
        });
      }
    } catch (error) {
      console.log('error', error);
    }
    setMyTicketsLoading(false);
  };

  const handleLandingPageOptions = (mobile = '') => {
    if (appState?.optionsData?.options?.length === 0 || isBusinessChange) {
      getOptions();
    }
    if (type) getTicketsData(type === 'user' ? mobile : '');
  };

  const reloadMyTickets = async () => {
    try {
      await getTicketsData();
    } catch (e) {
      console.error('Error fetching tickets while reloading', e);
    }
  };

  const handleKycRedirect = () => {
    if (kycRedirectUrl) {
      window.location.href = kycRedirectUrl;
    }
  };

  useEffect(() => {
    if (((type === 'business' && selectedBusiness?.docid) || type === 'user') && userDetails?.mobile) {
      handleLandingPageOptions(userDetails?.mobile);
    }
    if (appState?.optionsData?.options?.length > 0 || (appState?.loginPopup?.nonlogin && !appState?.sidResponse)) {
      setLoader(false);
    }
    setTimeout(() => {
      setLoader(false);
    }, 6000);
  }, [selectedBusiness?.docid, type, appState?.loginPopup?.nonlogin, userDetails?.mobile]);

  useEffect(() => {
    if (kycStatus === 'pending' && selectedBusiness?.docid) {
      sessionStorage.setItem('kycPopupDismissed', '0');
      sessionStorage.setItem('kycBannerDismissed', '0');
      setShowKycPopup(true);
      setShowKycBanner(true);
    }
  }, [selectedBusiness?.docid, kycStatus]);

  const features = appState?.optionsData?.options?.length > 0 ? appState.optionsData.options : optionsData;
  const ticketsData = appState?.ticketsData && appState?.ticketsData.length > 0 ? appState?.ticketsData : myTicketsData;

  const handleCancelSendCommunication = () => {
    sessionStorage.setItem('communicationSentFlag', 1);
  };

  const handleAddOnsClick = async () => {
    try {
      if (contractType && contractType !== 'user') {
        await clickTracker('issue_addons', `${trackUserType?.[contractType]}_issue`);
        const liVal = 'impression';
        const liTrd = 'addon_FAQ_view';
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = 'addon_FAQ';
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
        const addOnsParams = {
          parentId: selectedBusiness?.parentid || '',
          city: selectedBusiness?.data_city,
          source,
          contractType,
          shortUrl: selectedBusiness?.shorturl || '',
        };
        const addOnsResp = await getAddOnCampaigns(addOnsParams);
        if (addOnsResp?.errorCode === 0) {
          if (addOnsResp?.result?.length > 0) {
            document.body.style.overflow = 'hidden';
            setAddOnsData(addOnsResp?.result || []);
          } else {
            setAlert({
              message: 'All your campaigns are active',
              status: true,
            });
          }
        } else {
          setAlert({
            message: 'Something went wrong',
            status: false,
          });
        }
      }
    } catch (err) {
      console.log('error in getAddOnCampaigns', err);
    }
  };

  return (
    <>
      {loader ? (
        <Shimmer loading id="features" />
      ) : (
        <>
          {ecsInactivePopupData &&
          Object.keys(ecsInactivePopupData).length > 0 &&
          ecsInactivePopupData?.ecsStatus &&
          !storedInactiveDataArr?.opened &&
          appState?.popupObj?.popupType !== 'selectBusiness' ? (
            <EcsInactiveModal
              ecsInactivePopupData={ecsInactivePopupData}
              setEcsInactivePopupData={setEcsInactivePopupData}
            />
          ) : (
            features &&
            features.length > 0 && (
              <section
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
                onClick={handleCancelSendCommunication}
                className="cspage cstickets no-highlighting"
              >
                {(type === 'business' || !appState?.loginPopup?.nonlogin) && (
                  <DynamicSearchBar
                    handleOptionClick={handleOptionClick}
                    contractType={appState?.optionsData?.contractType}
                    ecsFlag={appState?.optionsData?.ecsFlag || false}
                    jdrrBannerFlag={appState?.optionsData?.jdrrBannerFlag || false}
                    page="csportal"
                  />
                )}

                <div className="cshotkeybox p-20" style={{ paddingBottom: kycStatus === 'pending' ? '70px' : '' }}>
                  <div className="hotkeybox_text">
                    <div className={`${styles.Contract__Heading} font16 fw600 color111 color111 text_center`}>
                      Hi! How can we help you today?
                    </div>
                  </div>
                  <ul className="hotkeybox_listgroup">
                    {features &&
                      features.map((each, idx) => (
                        <li key={idx} className={`${styles.Contract__ListGroupItem} `}>
                          <div
                            aria-label="features_click"
                            tabIndex={0}
                            role="button"
                            onKeyDown={() => {}}
                            onClick={() => {
                              if (each?.key === 'addOns') {
                                handleAddOnsClick();
                              } else {
                                handleOptionClick(each);
                              }
                            }}
                            className={`${styles.Contract__ListGroupAnchor} whitefill_animate`}
                          >
                            <div className={`csicon hotkeybox_icon ${each.icon}`} />
                            <div className={`${styles.Contract__ListGroupText} pl-12 pr-20`}>
                              <div className="font14 fw600 color111">{each.title}</div>
                              {each?.key === 'addOns' && (
                                <span className={`${styles.Contract__ListGroupNew} font10 fw600 colorFFF ml-12`}>
                                  New
                                </span>
                              )}
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
                {((contractType && !['expiredLong', 'free'].includes(contractType)) ||
                  (contractType && hasJdMartVertical())) &&
                ticketsData &&
                ticketsData?.length ? (
                  <MyTickets
                    reloadMyTickets={reloadMyTickets}
                    loading={myTicketsLoading}
                    myTicketsData={ticketsData}
                    id="allTickets"
                    handleOnLanding={handleOnLanding}
                    trackPage="landing"
                  />
                ) : null}

                {kycStatus === 'pending' && showKycBanner && (
                  <KycPendingFooter setShowKycBanner={setShowKycBanner} handleKycRedirect={handleKycRedirect} />
                )}

                {kycStatus === 'pending' && showKycPopup && (
                  <KycPendingModal setShowKycPopup={setShowKycPopup} handleKycRedirect={handleKycRedirect} />
                )}

                {(sessionStorage.getItem('landingPageUserType') === 'business' || sidResponse) && (
                  <Business handleOnLanding={handleOnLanding} />
                )}
              </section>
            )
          )}
          {addOnsData && addOnsData?.length > 0 && (
            <AddOnModal selectedBusiness={selectedBusiness} setAddOnsData={setAddOnsData} addOnsData={addOnsData} />
          )}
        </>
      )}
    </>
  );
};

export default LoggedIn;

LoggedIn.propTypes = {
  handleOptionClick: PropTypes.func,
  isBusinessChange: PropTypes.bool,
  setOptionsTrackerData: PropTypes.func,
  handleOnLanding: PropTypes.func,
  kycStatus: PropTypes.string,
  kycRedirectUrl: PropTypes.string,
};
